<script lang="ts">
    import { customStatusIconsType1 } from "../../../config"
    import { getCustomStatusIconObj, getOpCustomNote, getOpCustomStatus } from "../../../helper"
    import Icon from "../Icon.svelte"
    import { _ } from "svelte-i18n"
    export let operation: Operation | OperationOut, type: "Internal" | "Dealer"
    const defaultCustomOpStatus = operation.type == 1 ? "open" : "waitingForResponse"
    let status = {
            value: getOpCustomStatus(operation, type) || defaultCustomOpStatus,
            label: customStatusIconsType1[getOpCustomStatus(operation, type) || defaultCustomOpStatus]?.title,
        },
        note = getOpCustomNote(operation, type) || ""

    function getLimitedLines(text: string, maxLines: number): string[] {
        const lines = text.split("\n")
        return lines.slice(0, maxLines)
    }
</script>

<style lang="less">
    .customDealerStatusTooltip {
        * {
            padding: 0px;
            margin: 0px;
        }
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 420px;
        align-items: flex-start;
        gap: 24px;

        section {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            font-size: 0.7rem;

            align-items: flex-start;
            h5 {
                line-height: 160%;
                font-weight: 400;
                text-transform: uppercase;
            }
            &.status {
                div {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    padding-top: 6px;
                }
            }
            &.notes {
                p {
                    font-size: 0.8rem;
                    font-weight: 400 !important;
                    text-align: start;
                }
            }
            &.annotation {
                em {
                    font-style: normal;
                    color: var(--renzrot);
                }
            }
        }
    }
</style>

<div class="customDealerStatusTooltip">
    <section class="status">
        <h5>{$_("components.table.fields.status.status")}</h5>
        <div>
            <span class="stateButton extended {status.value}">
                <Icon path="{getCustomStatusIconObj(operation)[status.value]?.icon}" size="24px" />
            </span>
            <span style="margin-left: 10px;">{status.label}</span>
        </div>
    </section>
    <section class="notes">
        <h5>{$_("components.table.fields.status.notes")}</h5>
        {#if note && note.length > 0}
            <p>
                {#each getLimitedLines(note, 5) as paragraph, index (index)}
                    {paragraph}
                    {#if index < 4}
                        <br />
                    {/if}
                {/each}
                {#if note.split("\n").length > 5}
                    ...
                {/if}
            </p>
        {:else}
            <p>{$_("components.table.fields.status.noNotesAvailable")}</p>
        {/if}
    </section>
    <section class="annotation">
        <em>{$_("components.table.fields.status.clickIconToMakeChanges")}</em>
    </section>
</div>
